export default function FileLog(){
    return (
        <>
            {/* heading */}
			<h3 className="text-lg font-bold pb-2 w-full text-start secondaryFont">File Log</h3>
			{/* heading cnt-1 file logs */}
            <div className=" flex flex-col justify-center items-center w-full h-full primaryBColor rounded-xl capitalize md:w-[450px] lg:w-[500px]">
                <div className="flex justify-center items-cente w-full p-2 text-center m-auto">
                    <div className='w-1/3'>file_1</div>
                    <div className='w-1/3'>June 12</div>
                    <div className='w-1/3'>34 mb</div>
                </div>
                <div className="flex justify-center items-cente w-full p-2 text-center m-auto">
                    <div className='w-1/3'>file_1</div>
                    <div className='w-1/3'>June 12</div>
                    <div className='w-1/3'>34 mb</div>
                </div>
                <div className="flex justify-center items-cente w-full p-2 text-center m-auto">
                    <div className='w-1/3'>file_1</div>
                    <div className='w-1/3'>June 12</div>
                    <div className='w-1/3'>34 mb</div>
                </div>
                <div className="flex justify-center items-cente w-full p-2 text-center  m-auto">
                    <div className='w-1/3'>file_1</div>
                    <div className='w-1/3'>June 12</div>
                    <div className='w-1/3'>34 mb</div>
                </div>
                <div className="flex justify-center items-cente w-full p-2 text-center">
                    <div className='w-1/3'>file_1</div>
                    <div className='w-1/3'>June 12</div>
                    <div className='w-1/3'>34 mb</div>
                </div>
            </div>
        </>
        )
}
